/* eslint-disable @typescript-eslint/no-unused-vars */

import { AxiosInstance, AxiosResponse } from "axios";

//Function to get fwaas list data
export function fetchFwaasList(
  api: AxiosInstance,
  tenantId: number,
): Promise<AxiosResponse> {
return api.get(`/kontroledge/fwaas?includeChildServices=true&includeFWInt=true&tenantId=${tenantId}`, {
});
}

// One Virtual Firewall: `details` (the list row), `vm` and `ha_members` (CTX-730)
export function fetchFwaasDetails(
  api: AxiosInstance,
  tenantId: number,
  fwaasId: string
): Promise<AxiosResponse> {
  return api.get(`/kontroledge/fwaas/${encodeURIComponent(fwaasId)}`, {
    params: { tenantId },
  });
}

//Function to get forti manager
export function fetchFortimanager(
  api: AxiosInstance,
  opts: { redirectTo: string; tenantId?: number; signal?: AbortSignal }
): Promise<AxiosResponse> {
  return api.get("/kontroledge/fwaas/get-access-fortimanager", {
    params: {
      redirect_to: opts.redirectTo,
      ...(opts.tenantId != null ? { tenantId: opts.tenantId } : {}),
    },
    signal: opts.signal,
  });
}

//Function to get forti manager
export function fetchCredentials(
  api: AxiosInstance,
  tenantId: number,
): Promise<AxiosResponse> {
return api.get(`/kontroledge/fwaas/fortimanager-credentials?tenantId=${tenantId}&includePassword=true`, {
});
}
